var map = {
	"./": 18305,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Assets/breakfast.jpg": 6830,
	"./Assets/dinner.png": 69576,
	"./Assets/drinks.png": 3351,
	"./Assets/food2.png": 81611,
	"./Assets/food21.png": 78263,
	"./Assets/lunch.jpg": 7472,
	"./Assets/nightlife.png": 71463,
	"./Assets/snacks.png": 93309,
	"./components/Api": 96242,
	"./components/Api.js": 96242,
	"./components/Header": 21609,
	"./components/Header.js": 21609,
	"./components/Mealtype": 32022,
	"./components/Mealtype.js": 32022,
	"./components/Quickseacrhes": 45205,
	"./components/Quickseacrhes.js": 45205,
	"./components/Restaurantdetails": 30661,
	"./components/Restaurantdetails.js": 30661,
	"./components/Wallpaper": 78142,
	"./components/Wallpaper.js": 78142,
	"./components/filters/Filter": 33438,
	"./components/filters/Filter.js": 33438,
	"./components/logincreditional/Headers": 58001,
	"./components/logincreditional/Headers.js": 58001,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./styles/Filter.css": 1899,
	"./styles/Restaurantdetails.css": 95118,
	"./styles/Wallpaper.css": 2520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;